import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';
import { Container, theme, useBreakpointHelpers, VStack } from '@sg/garnish';

import type { SweetpassUpgradeScreenPalette } from './SweetgreenUpgradeScreenPalette';
import { SweetpassBenefitCard } from './SweetpassBenefitCard';
import type { SweetpassUpgradeBenefitList } from './SweetpassUpgradeScreen.loaded';

type SweetpassUpgradeBenefitListContentProps = {
  readonly content: SweetpassUpgradeBenefitList;
  readonly palette: SweetpassUpgradeScreenPalette['benefitList'];
};
export const SweetpassUpgradeBenefitListContent = ({
  content,
  palette,
}: SweetpassUpgradeBenefitListContentProps) => {
  const { isMobile, isLargeDisplay, isDesktop } = useBreakpointHelpers();

  const BenefitsListWrapper = isMobile ? VStack : View;

  const containerStyle = useStyle(
    () => ({ backgroundColor: palette.backgroundColor }),
    [palette],
  );

  return (
    <Container testID="sweetpass-upgrade-benefits-list" customSpacing={0}>
      <BenefitsListWrapper
        testID={`sweetpass-upgrade-benefits-list-wrapper-${
          isMobile ? 'mobile' : 'desktop'
        }`}
        style={[
          !isMobile && styles.benefitsList,
          !(isDesktop || isLargeDisplay) && styles.benefitsListMobile,
          containerStyle,
        ]}
        divider
      >
        {content.benefits.map((benefitItem) => (
          <SweetpassBenefitCard
            key={benefitItem.id}
            content={benefitItem}
            palette={palette.benefit}
          />
        ))}
      </BenefitsListWrapper>
    </Container>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  benefitsList: {
    padding: theme.spacing.xxlarge,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  benefitsListMobile: {
    paddingVertical: theme.spacing.large,
    paddingHorizontal: theme.spacing.medium,
  },
});
